import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { FaqComponent } from './faq/faq.component';
import { MyaccountComponent } from './myaccount/myaccount.component';
import { TcComponent } from './tc/tc.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { HttpClientModule } from '@angular/common/http';
import { DetailsComponent } from './details/details.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MobileDialogComponent } from './mobile-dialog/mobile-dialog.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { PinDailogComponent } from './pin-dailog/pin-dailog.component';
import { ArcadeComponent } from './arcade/arcade.component';
import { AdventureComponent } from './adventure/adventure.component';
import { PlgComponent } from './plg/plg.component';
import { LiveLoadingComponent } from './live-loading/live-loading.component';
import { NewFaqComponent } from './new-faq/new-faq.component';
import { MsgDialogComponent } from './msg-dialog/msg-dialog.component';
import { ComvivaDialogComponent } from './comviva-dialog/comviva-dialog.component';
import { BlockerComponent } from './blocker/blocker.component';
import { HutchpopupComponent } from './hutchpopup/hutchpopup.component';



@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    FaqComponent,
    MyaccountComponent,
    TcComponent,
    DetailsComponent,

    MobileDialogComponent,
     LoginDialogComponent,
     PinDailogComponent,
     ArcadeComponent,
     AdventureComponent,
     PlgComponent,
     LiveLoadingComponent,
     NewFaqComponent,
     MsgDialogComponent,
     ComvivaDialogComponent,
     BlockerComponent,
     HutchpopupComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SlickCarouselModule,
    HttpClientModule,
    NgbModule,
    BrowserAnimationsModule,
    FormsModule,
    
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
